/* Regenliebe Merkliste (localStorage). Schluessel: rl_wishlist */
(() => {
  if (window.rlWishlist) return;
  const KEY = 'rl_wishlist';
  const EVT = 'rl:wishlist:updated';

  const read = () => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  };
  const write = (items) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {
      /* privater Modus oder voll */
    }
    window.dispatchEvent(new CustomEvent(EVT, { detail: { items, count: items.length } }));
  };
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  const api = {
    items: read,
    has: (id) => read().some((i) => String(i.id) === String(id)),
    remove(id) {
      write(read().filter((i) => String(i.id) !== String(id)));
    },
    toggle(item) {
      if (api.has(item.id)) {
        api.remove(item.id);
        return false;
      }
      write([item, ...read()]);
      return true;
    },
  };
  window.rlWishlist = api;

  function syncButtons() {
    document.querySelectorAll('[data-rl-wishlist-toggle]').forEach((btn) => {
      const on = api.has(btn.dataset.productId);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      const label = on ? btn.dataset.labelOn : btn.dataset.labelOff;
      if (label) btn.setAttribute('aria-label', label);
      const text = btn.querySelector('[data-rl-wishlist-text]');
      const want = on ? btn.dataset.textOn : btn.dataset.textOff;
      if (text && text.textContent !== want) text.textContent = want;
    });
  }

  function syncCounts() {
    const n = api.items().length;
    document.querySelectorAll('[data-rl-wishlist-count]').forEach((el) => {
      if (el.textContent !== String(n)) el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function money(cents) {
    const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* ---------- Merklisten-Seite ---------- */
  let refreshed = false;

  function refreshPrices(grid) {
    if (refreshed) return;
    refreshed = true;
    api.items().forEach((it) => {
      if (!it.handle) return;
      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'products/' + encodeURIComponent(it.handle) + '.js')
        .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
        .then((p) => {
          const card = grid.querySelector('[data-handle="' + CSS.escape(it.handle) + '"]');
          const priceEl = card && card.querySelector('[data-price]');
          if (!priceEl) return;
          priceEl.innerHTML = p.available
            ? (p.price_varies ? 'ab ' : '') + money(p.price) + (p.compare_at_price > p.price ? ' <s>' + money(p.compare_at_price) + '</s>' : '')
            : 'Ausverkauft';
        })
        .catch(() => {});
    });
  }

  function renderPage() {
    const root = document.querySelector('[data-rl-wishlist-page]');
    if (!root) return;
    const grid = root.querySelector('[data-rl-wishlist-grid]');
    const empty = root.querySelector('[data-rl-wishlist-empty]');
    const countEl = root.querySelector('[data-rl-wishlist-page-count]');
    const items = api.items();
    if (countEl) countEl.textContent = items.length === 1 ? '1 Produkt' : items.length + ' Produkte';
    empty.hidden = items.length > 0;
    grid.hidden = items.length === 0;
    grid.innerHTML = items
      .map(
        (it) => `
      <article class="rl-wl__item" data-handle="${esc(it.handle)}">
        <a class="rl-wl__media" href="${esc(it.url)}">
          ${it.image ? `<img src="${esc(it.image)}" alt="${esc(it.title)}" loading="lazy" width="400" height="500">` : ''}
        </a>
        <button type="button" class="rl-wl__remove" data-rl-wishlist-remove="${esc(it.id)}" aria-label="Von der Merkliste entfernen">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
        <a class="rl-wl__title" href="${esc(it.url)}">${esc(it.title)}</a>
        <span class="rl-wl__price" data-price>${esc(it.price)}</span>
        <a class="rl-wl__btn" href="${esc(it.url)}">Ansehen</a>
      </article>`
      )
      .join('');
    refreshPrices(grid);
  }

  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-rl-wishlist-remove]');
    if (rm) {
      e.preventDefault();
      api.remove(rm.dataset.rlWishlistRemove);
      return;
    }
    const btn = e.target.closest('[data-rl-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const d = btn.dataset;
    api.toggle({
      id: d.productId,
      handle: d.productHandle,
      title: d.productTitle,
      image: d.productImage,
      price: d.productPrice,
      url: d.productUrl,
    });
    btn.classList.add('is-pop');
    setTimeout(() => btn.classList.remove('is-pop'), 400);
  });

  const update = () => {
    syncButtons();
    syncCounts();
  };
  window.addEventListener(EVT, () => {
    update();
    renderPage();
  });
  window.addEventListener('storage', (e) => {
    if (e.key === KEY) {
      update();
      renderPage();
    }
  });
  window.addEventListener('pageshow', update);
  document.addEventListener('shopify:section:load', () => {
    update();
    renderPage();
  });

  // Dynamisch nachgeladene Karten (Quick Add, Filter, Section Rendering)
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      syncButtons();
      syncCounts();
    });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });

  const init = () => {
    update();
    renderPage();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
